module.exports = __webpack_public_path__ + "static/img/16.343ac51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/16.png
// module id = Vuaz
// module chunks = 0